import { render, staticRenderFns } from "./MailSvg.vue?vue&type=template&id=20909d9a&"
import script from "./MailSvg.vue?vue&type=script&lang=js&"
export * from "./MailSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports